import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryCards() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门<span className="text-accent-600">吃瓜</span>分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">按分类浏览你最感兴趣的吃瓜内容</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-background-100 hover:bg-accent-100/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-accent-600 group-hover:text-primary-900 transition-colors`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}